export const CROP_OFF = 0;
export const CROP_ON = 1;

export const allowedImgTypes = ["image/png", "image/jpg", "image/jpeg"];

export const CLASSES = [
  "Fake Black Label",
  "Fake Classic Label",
  "No Label Found (Try cropping your image)",
  "Real Black Label",
  "Real Classic Label",
];
